export const FileSize = {
    Original: -1,
    Small: 0,
    Medium: 1,
    Large: 2,
  };